import jQuery from 'jquery';

const initProductByCategory = () => {
	const app = document.getElementById('pbc-app');
	if (!app) return;

	// Elements
	const step1 = document.getElementById('pbc-step-1');

	// Buttons
	const btnToStep2 = document.getElementById('btn-to-step-2');

	// Stock Alert Helpers
	const showStockAlert = (msg) => {
		const alertEl = document.getElementById('pbc-stock-alert');
		const alertText = document.getElementById('pbc-stock-alert-text');
		if (alertEl && alertText) {
			alertText.textContent = msg || 'Het door u gekozen product is helaas uitverkocht.';
			alertEl.style.display = 'flex';
		}
	};

	const hideStockAlert = () => {
		const alertEl = document.getElementById('pbc-stock-alert');
		if (alertEl) {
			alertEl.style.display = 'none';
		}
	};

	// Re-order product items: De Essentie -> De Verdieping -> Retraite
	const sortProductsList = (container) => {
		if (!container) return;
		const items = Array.from(container.querySelectorAll('.pbc-product-item'));
		if (items.length <= 1) return;

		const getOrderScore = (item) => {
			const radio = item.querySelector('input[name="pbc_selected_product"]');
			const titleEl = item.querySelector('.pbc-product-title');
			const title = (
				(radio && radio.getAttribute('data-title')) ||
				(titleEl && titleEl.textContent) ||
				''
			).toLowerCase();

			if (title.includes('essentie')) return 1;
			if (title.includes('verdieping')) return 2;
			if (title.includes('retraite')) return 3;
			return 99;
		};

		items.sort((a, b) => getOrderScore(a) - getOrderScore(b));
		items.forEach((item) => container.appendChild(item));
	};

	// Initial sort for all product lists
	app.querySelectorAll('.pbc-products-list').forEach((list) => {
		sortProductsList(list);
	});

	// Dynamic [selected-product] widget updater
	const updateSelectedProductWidget = (radioInput) => {
		const spApp = document.getElementById('selected-product-app');
		if (!spApp) return;

		const emptyState = spApp.querySelector('.sp-empty-state');
		const card = spApp.querySelector('.sp-card');

		let benefitsSec = spApp.querySelector('.sp-benefits-section');

		if (!radioInput || !radioInput.checked || radioInput.disabled || !radioInput.value) {
			if (emptyState) emptyState.style.display = 'flex';
			if (card) card.style.display = 'none';
			if (benefitsSec) benefitsSec.style.display = 'none';
			return;
		}

		const title = radioInput.getAttribute('data-title') || '';
		const subtitle = radioInput.getAttribute('data-subtitle') || '';
		let date = radioInput.getAttribute('data-date') || '';
		let price = radioInput.getAttribute('data-price') || '';
		let image = radioInput.getAttribute('data-image') || '';
		const iconHtml = radioInput.getAttribute('data-icon-html') || '';
		const benefitsData = radioInput.getAttribute('data-benefits') || '';

		const itemLabel = radioInput.closest('.pbc-product-item');
		if (itemLabel) {
			const selectEl = itemLabel.querySelector('.pbc-date-select');
			if (selectEl && selectEl.value) {
				const opt = selectEl.options[selectEl.selectedIndex];
				if (opt && !opt.disabled) {
					if (opt.getAttribute('data-date')) date = opt.getAttribute('data-date');
					if (opt.getAttribute('data-price')) price = opt.getAttribute('data-price');
					if (opt.getAttribute('data-loc')) {
						const locVal = opt.getAttribute('data-loc');
						const locAttrVal = itemLabel.querySelector('.pbc-attr-location-val');
						if (locAttrVal) locAttrVal.textContent = locVal;
						radioInput.setAttribute('data-loc', locVal);
					}
				}
			}
		}

		const titleEl = spApp.querySelector('.sp-title');
		const subtitleEl = spApp.querySelector('.sp-subtitle');
		const dateEl = spApp.querySelector('.sp-date-val');
		const dateItem = spApp.querySelector('.sp-date-item');
		const priceEl = spApp.querySelector('.sp-price-val');
		const priceItem = spApp.querySelector('.sp-price-item');
		const imgEl = spApp.querySelector('.sp-img');

		if (titleEl) titleEl.textContent = title;
		if (subtitleEl) {
			subtitleEl.textContent = subtitle;
			subtitleEl.style.display = subtitle ? 'block' : 'none';
		}
		if (dateEl && dateItem) {
			dateEl.textContent = date;
			dateItem.style.display = date ? 'flex' : 'none';
		}
		if (priceEl && priceItem) {
			priceEl.innerHTML = price;
			priceItem.style.display = price ? 'flex' : 'none';
		}
		if (imgEl) {
			if (image) {
				imgEl.src = image;
				imgEl.style.display = 'block';
			} else {
				imgEl.style.display = 'none';
			}
		}

		const showIcon = spApp.getAttribute('data-show-icon') !== '0';
		const showList = spApp.getAttribute('data-show-list') !== '0';

		if (!benefitsSec) {
			benefitsSec = spApp.querySelector('.sp-benefits-section');
		}
		if (!benefitsSec) {
			benefitsSec = document.createElement('div');
			benefitsSec.className = 'sp-benefits-section';
			spApp.appendChild(benefitsSec);
		}

		let iconContainer = spApp.querySelector('.sp-goal-icon');
		if (showIcon) {
			if (!iconContainer) {
				iconContainer = document.createElement('div');
				iconContainer.className = 'sp-goal-icon';
				benefitsSec.appendChild(iconContainer);
			}
			if (iconHtml) {
				iconContainer.innerHTML = iconHtml;
				iconContainer.style.display = 'block';
			} else {
				iconContainer.style.display = 'none';
			}
		} else if (iconContainer) {
			iconContainer.style.display = 'none';
		}

		let benefitsListEl = spApp.querySelector('.sp-benefits-list');
		if (showList) {
			if (!benefitsListEl) {
				benefitsListEl = document.createElement('ul');
				benefitsListEl.className = 'sp-benefits-list';
				benefitsSec.appendChild(benefitsListEl);
			}
			if (benefitsData) {
				try {
					const benefits = JSON.parse(benefitsData);
					if (Array.isArray(benefits) && benefits.length > 0) {
						benefitsListEl.innerHTML = benefits.map((b) => `
							<li class="sp-benefit-item">
								<svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path d="M8.33333 0C3.74167 0 0 3.74167 0 8.33333C0 12.925 3.74167 16.6667 8.33333 16.6667C12.925 16.6667 16.6667 12.925 16.6667 8.33333C16.6667 3.74167 12.925 0 8.33333 0ZM12.3167 6.41667L7.59167 11.1417C7.475 11.2583 7.31667 11.325 7.15 11.325C6.98333 11.325 6.825 11.2583 6.70833 11.1417L4.35 8.78333C4.10833 8.54167 4.10833 8.14167 4.35 7.9C4.59167 7.65833 4.99167 7.65833 5.23333 7.9L7.15 9.81667L11.4333 5.53333C11.675 5.29167 12.075 5.29167 12.3167 5.53333C12.5583 5.775 12.5583 6.16667 12.3167 6.41667Z" fill="#113545" />
								</svg>
								<span>${b}</span>
							</li>
						`).join('');
					}
				} catch (e) {
					console.error('Error parsing benefits JSON:', e);
				}
			}
		} else if (benefitsListEl) {
			benefitsListEl.style.display = 'none';
		}

		if (emptyState) emptyState.style.display = 'none';
		if (card) card.style.display = 'flex';
		if (benefitsSec) {
			benefitsSec.style.display = (showIcon || showList) ? 'flex' : 'none';
		}
	};

	// Tabs
	const tabBtns = app.querySelectorAll('.pbc-tab-btn');
	const tabContents = app.querySelectorAll('.pbc-tab-content');

	tabBtns.forEach((btn) => {
		btn.addEventListener('click', function (e) {
			e.preventDefault();
			const targetId = this.getAttribute('data-target');
			tabBtns.forEach((b) => b.classList.remove('active'));
			tabContents.forEach((c) => {
				c.classList.remove('active');
				c.style.display = 'none';
			});
			this.classList.add('active');
			const targetContent = document.getElementById(targetId);
			if (targetContent) {
				targetContent.classList.add('active');
				targetContent.style.display = 'block';
			}
		});
	});

	// Load More
	const loadMoreBtns = app.querySelectorAll('.pbc-load-more-btn');
	loadMoreBtns.forEach((btn) => {
		btn.addEventListener('click', function (e) {
			e.preventDefault();
			const originalText = this.innerHTML;
			this.innerHTML = 'Laden...';
			this.disabled = true;

			const category = this.getAttribute('data-category');
			const page = parseInt(this.getAttribute('data-page'));
			const targetListId = this.getAttribute('data-target-list');
			const targetList = document.getElementById(targetListId);

			const ajaxUrl = app.getAttribute('data-ajax-url');
			const nonce = app.getAttribute('data-nonce');

			if (typeof jQuery !== 'undefined' && ajaxUrl && nonce) {
				jQuery.ajax({
					url: ajaxUrl,
					type: 'POST',
					data: {
						action: 'pbc_load_more',
						nonce: nonce,
						category: category,
						page: page,
					},
					success: (response) => {
						this.innerHTML = originalText;
						this.disabled = false;
						if (response.success) {
							if (targetList) {
								jQuery(targetList).append(response.data.html);
								sortProductsList(targetList);
							}
							this.setAttribute('data-page', page + 1);
							if (!response.data.has_more) {
								this.style.display = 'none';
							}
						} else {
							alert('Error: ' + (response.data.message || 'Failed to load more.'));
						}
					},
					error: () => {
						this.innerHTML = originalText;
						this.disabled = false;
						alert('An error occurred. Please try again.');
					},
				});
			}
		});
	});

	// STEP 1 -> STEP 2
	if (btnToStep2) {
		// Prevent clicks inside date selector container from triggering outer <label> radio click
		app.addEventListener('click', (e) => {
			if (e.target.closest('.pbc-date-selector-container')) {
				e.stopPropagation();
				return;
			}

			const itemLabel = e.target.closest('.pbc-product-item');
			if (itemLabel) {
				const radio = itemLabel.querySelector('input[name="pbc_selected_product"]');
				if (radio && !radio.disabled && !radio.checked) {
					radio.checked = true;
					radio.dispatchEvent(new Event('change', { bubbles: true }));
				}
			}
		});

		// Radio selection change
		app.addEventListener('change', (e) => {
			if (e.target.name === 'pbc_selected_product') {
				const selectedRadio = e.target;
				const itemLabel = selectedRadio.closest('.pbc-product-item');

				// Hide all other date selector containers across all cards
				app.querySelectorAll('.pbc-date-selector-container').forEach((container) => {
					if (!itemLabel || !itemLabel.contains(container)) {
						container.style.display = 'none';
					}
				});

				if (!itemLabel) return;

				if (selectedRadio.disabled || selectedRadio.getAttribute('data-in-stock') === '0') {
					selectedRadio.checked = false;
					btnToStep2.disabled = true;
					btnToStep2.style.opacity = '0.5';
					btnToStep2.style.cursor = 'not-allowed';
					showStockAlert('Het gekozen product is helaas uitverkocht (0 plekken beschikbaar). Selecteer a.u.b. een ander product of datum.');
					updateSelectedProductWidget(null);
					return;
				}

				const dateContainer = itemLabel.querySelector('.pbc-date-selector-container');
				const isVariable = selectedRadio.getAttribute('data-is-variable') === '1';

				if (isVariable && dateContainer) {
					dateContainer.style.display = 'flex';
					const selectEl = dateContainer.querySelector('.pbc-date-select');

					if (selectEl && selectEl.value && !selectEl.options[selectEl.selectedIndex].disabled) {
						selectedRadio.value = selectEl.value;
						const opt = selectEl.options[selectEl.selectedIndex];
						const locVal = opt ? opt.getAttribute('data-loc') : '';
						if (locVal) {
							selectedRadio.setAttribute('data-loc', locVal);
							const locAttrVal = itemLabel.querySelector('.pbc-attr-location-val');
							if (locAttrVal) locAttrVal.textContent = locVal;
						}
						hideStockAlert();
						btnToStep2.disabled = false;
						btnToStep2.style.opacity = '1';
						btnToStep2.style.cursor = 'pointer';
					} else {
						selectedRadio.value = '';
						const initialLoc = selectedRadio.getAttribute('data-initial-loc') || '';
						if (initialLoc) {
							selectedRadio.setAttribute('data-loc', initialLoc);
							const locAttrVal = itemLabel.querySelector('.pbc-attr-location-val');
							if (locAttrVal) locAttrVal.textContent = initialLoc;
						}
						btnToStep2.disabled = true;
						btnToStep2.style.opacity = '0.5';
						btnToStep2.style.cursor = 'not-allowed';
						hideStockAlert();
					}
				} else {
					const initialLoc = selectedRadio.getAttribute('data-initial-loc') || selectedRadio.getAttribute('data-loc') || '';
					if (initialLoc) {
						const locAttrVal = itemLabel.querySelector('.pbc-attr-location-val');
						if (locAttrVal) locAttrVal.textContent = initialLoc;
					}
					hideStockAlert();
					btnToStep2.disabled = false;
					btnToStep2.style.opacity = '1';
					btnToStep2.style.cursor = 'pointer';
				}

				updateSelectedProductWidget(selectedRadio);
			}
		});

		// Date dropdown change
		app.addEventListener('change', (e) => {
			if (e.target.classList.contains('pbc-date-select')) {
				const selectEl = e.target;
				const itemLabel = selectEl.closest('.pbc-product-item');
				if (!itemLabel) return;

				const radioInput = itemLabel.querySelector('input[name="pbc_selected_product"]');
				const infoBox = itemLabel.querySelector('.pbc-date-info-box');
				const metaContainer = itemLabel.querySelector('.pbc-product-meta');
				const selectedOption = selectEl.options[selectEl.selectedIndex];
				const variationId = selectEl.value;

				if (variationId && selectedOption && !selectedOption.disabled) {
					if (radioInput) {
						radioInput.checked = true;
						radioInput.value = variationId;
					}

					hideStockAlert();

					const dateVal = selectedOption.getAttribute('data-date') || '';
					const labelVal = selectedOption.getAttribute('data-label') || 'Sessie:';
					const priceVal = selectedOption.getAttribute('data-price') || '';
					const stockVal = selectedOption.getAttribute('data-stock') || '';
					const locVal = selectedOption.getAttribute('data-loc') || '';

					// 1. Update Info Box below dropdown
					if (infoBox) {
						const dateLabelEl = infoBox.querySelector('.pbc-info-date-label');
						const dateEl = infoBox.querySelector('.pbc-info-date-val');
						const stockEl = infoBox.querySelector('.pbc-info-stock-val');
						const priceEl = infoBox.querySelector('.pbc-info-price-val');
						const locEl = infoBox.querySelector('.pbc-info-loc-val');

						if (dateLabelEl) dateLabelEl.textContent = labelVal;
						if (dateEl) dateEl.textContent = dateVal;
						if (stockEl) stockEl.textContent = stockVal;
						if (priceEl) priceEl.innerHTML = priceVal;
						if (locEl) locEl.textContent = locVal;

						infoBox.style.display = 'flex';
					}

					// 2. Update Top Meta Bar
					if (metaContainer) {
						const metaDate = metaContainer.querySelector('.pbc-meta-date');
						const metaPrice = metaContainer.querySelector('.pbc-meta-price');
						const metaSpots = metaContainer.querySelector('.pbc-meta-spots');

						if (metaDate && dateVal) metaDate.textContent = dateVal;
						if (metaPrice && priceVal) metaPrice.innerHTML = '<strong>' + priceVal + '</strong> excl. btw';
						if (metaSpots && stockVal) metaSpots.textContent = stockVal;
					}

					// 3. Update Location attribute in Card
					const locAttrVal = itemLabel.querySelector('.pbc-attr-location-val');
					const locAttrContainer = itemLabel.querySelector('.pbc-attr-location');
					const initialLoc = (locAttrContainer && locAttrContainer.getAttribute('data-initial-loc')) || (radioInput && radioInput.getAttribute('data-initial-loc')) || '';
					const newLoc = locVal || initialLoc;
					if (locAttrVal && newLoc) {
						locAttrVal.textContent = newLoc;
					}
					if (radioInput && newLoc) {
						radioInput.setAttribute('data-loc', newLoc);
					}

					btnToStep2.disabled = false;
					btnToStep2.style.opacity = '1';
					btnToStep2.style.cursor = 'pointer';
				} else {
					if (radioInput) {
						radioInput.value = '';
					}
					if (infoBox) {
						infoBox.style.display = 'none';
					}

					// Restore initial Top Meta Bar values
					if (metaContainer) {
						const metaDate = metaContainer.querySelector('.pbc-meta-date');
						const metaPrice = metaContainer.querySelector('.pbc-meta-price');
						const metaSpots = metaContainer.querySelector('.pbc-meta-spots');

						if (metaDate) metaDate.textContent = metaContainer.getAttribute('data-initial-date') || '';
						if (metaPrice) metaPrice.innerHTML = '<strong>' + (metaContainer.getAttribute('data-initial-price') || '') + '</strong> excl. btw';
						if (metaSpots) metaSpots.textContent = metaContainer.getAttribute('data-initial-spots') || '';
					}

					// Restore initial Location attribute in Card
					const locAttrVal = itemLabel.querySelector('.pbc-attr-location-val');
					const locAttrContainer = itemLabel.querySelector('.pbc-attr-location');
					const initialLoc = (locAttrContainer && locAttrContainer.getAttribute('data-initial-loc')) || (radioInput && radioInput.getAttribute('data-initial-loc')) || '';
					if (locAttrVal && initialLoc) {
						locAttrVal.textContent = initialLoc;
					}
					if (radioInput && initialLoc) {
						radioInput.setAttribute('data-loc', initialLoc);
					}

					btnToStep2.disabled = true;
					btnToStep2.style.opacity = '0.5';
					btnToStep2.style.cursor = 'not-allowed';

					if (selectedOption && selectedOption.disabled) {
						showStockAlert('De geselecteerde datum is helaas uitverkocht (0 plekken beschikbaar). Selecteer a.u.b. een andere datum.');
					} else {
						hideStockAlert();
					}
				}

				if (radioInput) {
					updateSelectedProductWidget(radioInput);
				}
			}
		});

		btnToStep2.addEventListener('click', function (e) {
			e.preventDefault();
			const selectedProduct = app.querySelector(
				'input[name="pbc_selected_product"]:checked',
			);
			if (!selectedProduct) {
				showStockAlert('Selecteer a.u.b. eerst een product of een datum.');
				return;
			}

			if (
				selectedProduct.disabled ||
				selectedProduct.getAttribute('data-in-stock') === '0' ||
				!selectedProduct.value ||
				selectedProduct.value === '0'
			) {
				btnToStep2.disabled = true;
				btnToStep2.style.opacity = '0.5';
				btnToStep2.style.cursor = 'not-allowed';
				showStockAlert('Het gekozen product of de geselecteerde datum is helaas uitverkocht of niet geldig. Selecteer a.u.b. een ander product of datum.');
				return;
			}

			const originalText = btnToStep2.innerHTML;
			btnToStep2.innerHTML = 'Processing...';
			btnToStep2.disabled = true;

			const ajaxUrl = app.getAttribute('data-ajax-url');
			const nonce = app.getAttribute('data-nonce');

			if (typeof jQuery !== 'undefined' && ajaxUrl && nonce) {
				jQuery.ajax({
					url: ajaxUrl,
					type: 'POST',
					dataType: 'json',
					data: {
						action: 'set_product_session',
						nonce: nonce,
						product_id: selectedProduct.value,
					},
					success: function (response) {
						btnToStep2.innerHTML = originalText;
						btnToStep2.disabled = false;
						if (response.success) {
							window.location.href = '/inschrijven-stap-2';
						} else {
							showStockAlert('Fout: ' + (response.data.message || 'Validatie mislukt.'));
						}
					},
					error: function (xhr) {
						btnToStep2.innerHTML = originalText;
						btnToStep2.disabled = false;
						let msg = 'Er is een fout opgetreden. Probeer het opnieuw.';
						if (xhr && xhr.responseJSON && xhr.responseJSON.data && xhr.responseJSON.data.message) {
							msg = xhr.responseJSON.data.message;
						}
						showStockAlert(msg);
					},
				});
			} else {
				showStockAlert('Configuratiefout: AJAX URL of nonce niet gevonden.');
				btnToStep2.innerHTML = originalText;
				btnToStep2.disabled = false;
			}
		});
	}

	// Auto-select product / variation from URL parameters (e.g. from [training-variations-table] "Inschrijven" button)
	const urlParams = new URLSearchParams(window.location.search);
	const targetProductId = app.getAttribute('data-auto-select-product') || urlParams.get('select_product') || urlParams.get('product_id');
	const targetVariationId = app.getAttribute('data-auto-select-variation') || urlParams.get('variation_id');

	if (targetProductId || targetVariationId) {
		setTimeout(() => {
			let radioToSelect = null;

			if (targetProductId) {
				radioToSelect = app.querySelector(`input[name="pbc_selected_product"][data-product-id="${targetProductId}"]`);
			}

			if (!radioToSelect && targetVariationId) {
				const selectOption = app.querySelector(`.pbc-date-select option[value="${targetVariationId}"]`);
				if (selectOption) {
					const cardItem = selectOption.closest('.pbc-product-item');
					if (cardItem) {
						radioToSelect = cardItem.querySelector('input[name="pbc_selected_product"]');
					}
				}
			}

			if (!radioToSelect && targetProductId) {
				const selectOption = app.querySelector(`.pbc-date-select option[value="${targetProductId}"]`);
				if (selectOption) {
					const cardItem = selectOption.closest('.pbc-product-item');
					if (cardItem) {
						radioToSelect = cardItem.querySelector('input[name="pbc_selected_product"]');
					}
				}
			}

			if (radioToSelect) {
				// 1. Switch to the category tab containing this product
				const parentTabContent = radioToSelect.closest('.pbc-tab-content');
				if (parentTabContent) {
					const tabId = parentTabContent.id;
					const matchingTabBtn = app.querySelector(`.pbc-tab-btn[data-target="${tabId}"]`);
					if (matchingTabBtn && !matchingTabBtn.classList.contains('active')) {
						matchingTabBtn.click();
					}
				}

				// Check stock status before checking radio
				const isOut = radioToSelect.disabled || radioToSelect.getAttribute('data-in-stock') === '0';

				if (isOut) {
					if (btnToStep2) {
						btnToStep2.disabled = true;
						btnToStep2.style.opacity = '0.5';
						btnToStep2.style.cursor = 'not-allowed';
					}
					showStockAlert('Het door u gekozen product is helaas uitverkocht (0 plekken beschikbaar). Selecteer a.u.b. een ander product of datum.');
					updateSelectedProductWidget(null);
				} else {
					// 2. Select the product radio and trigger change
					radioToSelect.checked = true;
					radioToSelect.dispatchEvent(new Event('change', { bubbles: true }));
				}

				// 3. Select the variation in date dropdown if provided
				if (targetVariationId) {
					const cardItem = radioToSelect.closest('.pbc-product-item');
					if (cardItem) {
						const dateSelect = cardItem.querySelector('.pbc-date-select');
						if (dateSelect) {
							const targetOpt = dateSelect.querySelector(`option[value="${targetVariationId}"]`);
							dateSelect.value = targetVariationId;
							dateSelect.dispatchEvent(new Event('change', { bubbles: true }));

							if (targetOpt && targetOpt.disabled) {
								if (btnToStep2) {
									btnToStep2.disabled = true;
									btnToStep2.style.opacity = '0.5';
									btnToStep2.style.cursor = 'not-allowed';
								}
								showStockAlert('De door u geselecteerde datum is helaas uitverkocht (0 plekken beschikbaar). Selecteer a.u.b. een andere datum.');
							}
						}
					}
				}
				updateSelectedProductWidget(radioToSelect);
			}
		}, 300);
	} else {
		const preChecked = app.querySelector('input[name="pbc_selected_product"]:checked');
		if (preChecked) {
			updateSelectedProductWidget(preChecked);
		} else {
			updateSelectedProductWidget(null);
		}
	}
};

try {
	initProductByCategory();
} catch (e) {
	console.error('Error initProductByCategory:', e);
}
